import SimpleResourceList from "./SimpleResourceList";
export default SimpleResourceList;
